export default __webpack_public_path__ + "static/media/definition_actif.6185e939.svg";